import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout.vue'
import { getToken, setCampusId } from '../utils/auth'
// import store from '../store/index'
// 二级路由
// 
// 不需要登录拦截的路由配置
const loginIgnore = {
  paths: ['/login', '/register'],   //根据路由fullPath匹配
  /**
   * 判断路由是否包含在该配置中
   * @param route vue-router 的 route 对象
   * @returns {boolean}
   */
  includes(route) {
    return this.paths.includes(route.path)
  }
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: '/index',
        name: '首页',
        component: () => import('../views/home'),
        meta: {
          isKeepLive: true
        }
      },
      {
        path: '/orderadd',
        name: '预约',
        component: () => import('../views/order/add')
      },
      {
        path: '/orderlist',
        name: '预约记录',
        component: () => import('../views/order/list')
      },
      {
        path: '/addverify',
        name: '登记审批',
        component: () => import('../views/order/addverify')
      },
      
      {
        path: '/orderdetail',
        name: '订单详情',
        component: () => import('../views/order/orderDetail')
      },
      {
        path: '/ordernotice',
        name: '预约须知',
        component: () => import('../views/order/orderNotice')
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/login')
  },
  {
    path: '/register',
    name: '隐私条款',
    component: () => import('../views/login/register')
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.query?.campusId) { // 发现地址上有校区ID就存储起来
    setCampusId(to.query.campusId)
  }
  if (!loginIgnore.includes(to) && !getToken()) {
    next({path: '/login'})
  } else if (to.path === '/' || loginIgnore.includes(to) && getToken()) {
    if (from.fullPath !== '/') {
      next({path: from.fullPath})
    } else {
      next({path: '/index'})
    }
  } else {
    next()
  }
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
